<template>
  <b-container fluid>
    <b-row>
      <b-col lg="2">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>Total revenue</h6>
            </div>
            <div
              class="
                iq-customer-box
                d-flex
                align-items-center
                justify-content-between
                mt-3
              "
            >
              <div class="d-flex align-items-center">
                <div class="rounded-circle iq-card-icon iq-bg-success mr-2">
                  <i class="ri-trophy-line"></i>
                </div>
                <h3 data-cy="dashboard-total-revenue">
                  {{ totalRevenue | formatCurrency | notAvailable }}
                </h3>
              </div>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="2">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>Total company leads</h6>
            </div>
            <div
              class="
                iq-customer-box
                d-flex
                align-items-center
                justify-content-between
                mt-3
              "
            >
              <div class="d-flex align-items-center">
                <div class="rounded-circle iq-card-icon iq-bg-primary mr-2">
                  <i class="ri-question-answer-line"></i>
                </div>
                <h3 data-cy="dashboard-total-company-leads">
                  {{ topStats ? topStats.openedCompanyLeads.aggregate.count : "0" }}
                </h3>
              </div>
              <!-- <div class="iq-map text-danger font-size-32"><i class="ri-bar-chart-grouped-line"></i></div> -->
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="2">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>Sent campaigns</h6>
              <!-- <span class="iq-icon">
                <i class="ri-information-fill"></i>
              </span> -->
            </div>
            <div
              class="
                iq-customer-box
                d-flex
                align-items-center
                justify-content-between
                mt-3
              "
            >
              <div class="d-flex align-items-center">
                <div class="rounded-circle iq-card-icon iq-bg-info mr-2">
                  <i class="ri-mail-send-line"></i>
                </div>
                <h3 data-cy="dashboard-sent-campaigns">
                  {{ topStats ? topStats.sentCampaigns.aggregate.count : "-" }}
                </h3>
              </div>
              <!-- <div class="iq-map text-primary font-size-32"><i class="ri-bar-chart-grouped-line"></i></div> -->
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="2">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>Delivery rate</h6>
              <!-- <span class="iq-icon">
                <i class="ri-information-fill"></i>
              </span> -->
            </div>
            <div
              class="
                iq-customer-box
                d-flex
                align-items-center
                justify-content-between
                mt-3
              "
            >
              <div class="d-flex align-items-center">
                <div class="rounded-circle iq-card-icon iq-bg-warning mr-2">
                  <i class="ri-inbox-line"></i>
                </div>
                <h3 data-cy="dashboard-delivery-rate">
                  {{
                    topStats
                      ? Math.round(
                          topStats.campaigns.stats.avg.delivery_rate * 100
                        )
                      : "-"
                  }}
                  %
                </h3>
              </div>
              <!-- <div class="iq-map text-warning font-size-32"><i class="ri-bar-chart-grouped-line"></i></div> -->
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="2">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>Open rate</h6>
              <!-- <span class="iq-icon">
                <i class="ri-information-fill"></i>
              </span> -->
            </div>
            <div
              class="
                iq-customer-box
                d-flex
                align-items-center
                justify-content-between
                mt-3
              "
            >
              <div class="d-flex align-items-center">
                <div class="rounded-circle iq-card-icon iq-bg-info mr-2">
                  <i class="ri-mail-open-line"></i>
                </div>
                <h3 data-cy="dashboard-open-rate">
                  {{
                    topStats
                      ? Math.round(topStats.campaigns.stats.avg.open_rate * 100)
                      : "-"
                  }}
                  %
                </h3>
              </div>
              <!-- <div class="iq-map text-info font-size-32"><i class="ri-bar-chart-grouped-line"></i></div> -->
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="2">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>Click through rate</h6>
              <!-- <span class="iq-icon">
                <i class="ri-information-fill"></i>
              </span> -->
            </div>
            <div
              class="
                iq-customer-box
                d-flex
                align-items-center
                justify-content-between
                mt-3
              "
            >
              <div class="d-flex align-items-center">
                <div class="rounded-circle iq-card-icon iq-bg-primary mr-2">
                  <i class="ri-cursor-line"></i>
                </div>
                <h3 data-cy="dashboard-click-rate">
                  {{
                    topStats
                      ? Math.round(topStats.campaigns.stats.avg.ctr * 100)
                      : "-"
                  }}
                  %
                </h3>
              </div>
              <!-- <div class="iq-map text-info font-size-32"><i class="ri-bar-chart-grouped-line"></i></div> -->
            </div>
          </template>
        </iq-card>
      </b-col>
      <!-- <b-col lg="2">
        <iq-card>
          <template v-slot:body>
            <div class="d-flex align-items-center justify-content-between">
              <h6>Bounce & Spam</h6>
              <span class="iq-icon"><i class="ri-information-fill"></i></span>
            </div>
            <div
              class="
                iq-customer-box
                d-flex
                align-items-center
                justify-content-between
                mt-3
              "
            >
              <div class="d-flex align-items-center">
                <div class="rounded-circle iq-card-icon iq-bg-danger mr-2">
                  <i class="ri-refund-line"></i>
                </div>
                <h3>
                  {{
                    topStats
                      ? Math.round(
                          topStats.campaigns.stats.avg.bounce_rate * 100
                        )
                      : "-"
                  }}
                  %
                </h3>
              </div>
            </div>
          </template>
        </iq-card>
      </b-col>-->
    </b-row>
    <!-- <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">HOT leads</h4>
          </template>
          <template v-slot:headerAction>
            <b-dropdown
              id="dropdownMenuButton5"
              right
              variant="none"
              data-toggle="dropdown"
            >
              <template v-slot:button-content>
                <span class="text-primary"><i class="ri-more-fill"></i></span>
              </template>
              <b-dropdown-item
                ><i class="ri-eye-fill mr-2"></i
                >{{ $t("dropdown.view") }}</b-dropdown-item
              >
              <b-dropdown-item
                ><i class="ri-delete-bin-6-fill mr-2"></i
                >{{ $t("dropdown.delete") }}</b-dropdown-item
              >
              <b-dropdown-item
                ><i class="ri-pencil-fill mr-2"></i
                >{{ $t("dropdown.edit") }}</b-dropdown-item
              >
              <b-dropdown-item
                ><i class="ri-printer-fill mr-2"></i
                >{{ $t("dropdown.print") }}</b-dropdown-item
              >
              <b-dropdown-item
                ><i class="ri-file-download-fill mr-2"></i
                >{{ $t("dropdown.download") }}</b-dropdown-item
              >
            </b-dropdown>
          </template>
          <template v-slot:body>
            <b-table responsive :items="items" class="mb-0 table-borderless">
              <template v-slot:cell(status)="data">
                <b-badge pill :variant="data.value.color">{{
                  data.value.name
                }}</b-badge>
              </template>
              <template v-slot:cell(amount)="data1">
                ${{ data1.value }}
              </template>
            </b-table>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="4">
      <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Next steps</h4>
          </template>
          <template v-slot:headerAction>
            <b-dropdown id="dropdownMenuButton5" right variant="none" data-toggle="dropdown">
              <template v-slot:button-content>
                <span class="text-primary"><i class="ri-more-2-fill"></i></span>
              </template>
              <b-dropdown-item><i class="ri-eye-fill mr-2"></i>{{ $t('dropdown.view') }}</b-dropdown-item>
              <b-dropdown-item><i class="ri-delete-bin-6-fill mr-2"></i>{{ $t('dropdown.delete') }}</b-dropdown-item>
              <b-dropdown-item><i class="ri-pencil-fill mr-2"></i>{{ $t('dropdown.edit') }}</b-dropdown-item>
              <b-dropdown-item><i class="ri-printer-fill mr-2"></i>{{ $t('dropdown.print') }}</b-dropdown-item>
              <b-dropdown-item><i class="ri-file-download-fill mr-2"></i>{{ $t('dropdown.download') }}</b-dropdown-item>
            </b-dropdown>
          </template>
          <template v-slot:body>
            <div class="m-0 p-0 d-flex flex-wrap align-items-center justify-content-between">
              <div class="col-md-12">
                <div class="d-flex align-items-center  mt-4">
                  <div class="iq-scale-border mr-3 repost-block"></div>
                  <div class="iq-scale-content">
                    <h6>2.864</h6>
                    <p class="mb-0">HOT leads to contact</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex align-items-center  mt-4">
                  <div class="iq-scale-border mr-3 comment-block"></div>
                  <div class="iq-scale-content">
                    <h6>624</h6>
                    <p class="mb-0">Meetings scheduled</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="d-flex align-items-center mt-4">
                  <div class="iq-scale-border mr-3 view-block"></div>
                  <div class="iq-scale-content">
                    <h6>1.75</h6>
                    <p class="mb-0">Contracts to finalize</p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </iq-card>
    </b-col>
    </b-row>-->
    <b-row>
      <b-col lg="6">
        <iq-card>
          <template v-slot:headerTitle>
            <h4>Company leads count per stage</h4>
          </template>
          <template v-slot:body>
            <ApexChart
              v-if="barChart"
              :element="barChart.type"
              :chartOption="barChart.bodyData"
            />
          </template>
        </iq-card>
      </b-col>
      <b-col lg="6">
        <iq-card>
          <template v-slot:headerTitle>
            <h4>Revenue summary per stage</h4>
          </template>
          <template v-slot:body>
            <ApexChart
              v-if="barChart2"
              :element="barChart2.type"
              :chartOption="barChart2.bodyData"
            />
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <div class="row">
      <b-col>
        <iq-card>
          <template v-slot:headerTitle>
            <h4>HOT company leads</h4>
          </template>
          <template v-slot:body>
            <b-table
              hover
              responsive
              :items="companyLeadItems"
              :fields="fields"
              class="mb-0 table-borderless"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <template #table-busy>
                <div class="text-center p-4" style="color: var(--iq-primary)">
                  <b-spinner class="align-middle mr-3"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(cluster)="data">
                <LeadClusterBadge :cluster="data.value" />
              </template>
              <template v-slot:cell(company)="data">
                <router-link
                  v-if="$allowedRoute('company-leads.detail')"
                  :to="{
                    path: `/company-leads/${data.item.id}`,
                  }"
                >
                  <h6>
                    {{ data.value.name }}
                  </h6>
                </router-link>
                <h6 v-else>
                  {{ data.value.name }}
                </h6>
              </template>
              <template v-slot:cell(stage_id)="data">
                <LeadStageBadge :stageId="data.value" />
              </template>
              <template v-slot:cell(campaign)="data">
                <h6>{{ data.value.name }}</h6>
              </template>
              <template v-slot:cell(last_activity)="data">
                <h6>{{ data.value | formatDate | notAvailable }}</h6>
              </template>
              <template v-slot:cell(priority_index)="data">
                <h6>{{ data.value }}</h6>
              </template>
              <template v-slot:cell(number_of_clicks)="data">
                <h6>{{ data.value }}</h6>
              </template>
            </b-table>
          </template>
        </iq-card>
      </b-col>
    </div>
    <!-- <b-row>
      <b-col md="8">
        <b-row>
          <b-col md="6">
            <iq-card body-class="p-0">
              <template v-slot:body>
                <b-img
                  :src="require('../../assets/images/booking/booking-03.png')"
                  alt="03"
                  fluid
                  class="rounded"
                />
              </template>
            </iq-card>
          </b-col>
          <b-col md="6">
            <iq-card body-class="p-0">
              <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t("dashboard1.exchangeRates") }}</h4>
              </template>
              <template v-slot:headerAction>
                <b-dropdown
                  id="dropdownMenuButton1"
                  right
                  variant="none"
                  data-toggle="dropdown"
                >
                  <template v-slot:button-content>
                    <span class="text-primary"
                      ><i class="ri-more-fill"></i
                    ></span>
                  </template>
                  <b-dropdown-item
                    ><i class="ri-eye-fill mr-2"></i
                    >{{ $t("dropdown.view") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-delete-bin-6-fill mr-2"></i
                    >{{ $t("dropdown.delete") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-pencil-fill mr-2"></i
                    >{{ $t("dropdown.edit") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-printer-fill mr-2"></i
                    >{{ $t("dropdown.print") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-file-download-fill mr-2"></i
                    >{{ $t("dropdown.download") }}</b-dropdown-item
                  >
                </b-dropdown>
              </template>
              <template v-slot:body>
                <ApexChart element="home-chart-01" :chartOption="chart2" />
              </template>
            </iq-card>
          </b-col>
          <b-col md="6">
            <iq-card body-class="p-0">
              <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t("dashboard1.lastCosts") }}</h4>
              </template>
              <template v-slot:headerAction>
                <b-dropdown
                  id="dropdownMenuButton1"
                  right
                  variant="none"
                  data-toggle="dropdown"
                >
                  <template v-slot:button-content>
                    <span class="text-primary"
                      ><i class="ri-more-fill"></i
                    ></span>
                  </template>
                  <b-dropdown-item
                    ><i class="ri-eye-fill mr-2"></i
                    >{{ $t("dropdown.view") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-delete-bin-6-fill mr-2"></i
                    >{{ $t("dropdown.delete") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-pencil-fill mr-2"></i
                    >{{ $t("dropdown.edit") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-printer-fill mr-2"></i
                    >{{ $t("dropdown.print") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-file-download-fill mr-2"></i
                    >{{ $t("dropdown.download") }}</b-dropdown-item
                  >
                </b-dropdown>
              </template>
              <template v-slot:body>
                <AmChart
                  element="home-chart-05"
                  type="line-bar"
                  :height="180"
                />
              </template>
            </iq-card>
          </b-col>
          <b-col md="6">
            <iq-card body-class="p-0 position-relative">
              <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t("dashboard1.efficiency") }}</h4>
              </template>
              <template v-slot:headerAction>
                <b-dropdown
                  id="dropdownMenuButton1"
                  right
                  variant="none"
                  data-toggle="dropdown"
                >
                  <template v-slot:button-content>
                    <span class="text-primary"
                      ><i class="ri-more-fill"></i
                    ></span>
                  </template>
                  <b-dropdown-item
                    ><i class="ri-eye-fill mr-2"></i
                    >{{ $t("dropdown.view") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-delete-bin-6-fill mr-2"></i
                    >{{ $t("dropdown.delete") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-pencil-fill mr-2"></i
                    >{{ $t("dropdown.edit") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-printer-fill mr-2"></i
                    >{{ $t("dropdown.print") }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    ><i class="ri-file-download-fill mr-2"></i
                    >{{ $t("dropdown.download") }}</b-dropdown-item
                  >
                </b-dropdown>
              </template>
              <template v-slot:body>
                <ApexChart element="home-chart-03" :chartOption="chart3" />
              </template>
            </iq-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="4">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t("dashboard1.paymentHistory") }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-dropdown
              id="dropdownMenuButton1"
              right
              variant="none"
              data-toggle="dropdown"
            >
              <template v-slot:button-content>
                <span class="text-primary"><i class="ri-more-fill"></i></span>
              </template>
              <b-dropdown-item
                ><i class="ri-eye-fill mr-2"></i
                >{{ $t("dropdown.view") }}</b-dropdown-item
              >
              <b-dropdown-item
                ><i class="ri-delete-bin-6-fill mr-2"></i
                >{{ $t("dropdown.delete") }}</b-dropdown-item
              >
              <b-dropdown-item
                ><i class="ri-pencil-fill mr-2"></i
                >{{ $t("dropdown.edit") }}</b-dropdown-item
              >
              <b-dropdown-item
                ><i class="ri-printer-fill mr-2"></i
                >{{ $t("dropdown.print") }}</b-dropdown-item
              >
              <b-dropdown-item
                ><i class="ri-file-download-fill mr-2"></i
                >{{ $t("dropdown.download") }}</b-dropdown-item
              >
            </b-dropdown>
          </template>
          <template v-slot:body>
            <ul class="suggestions-lists m-0 p-0">
              <li
                v-for="(payment, index) in paymentHistory"
                :key="index"
                class="d-flex mb-4 align-items-center"
              >
                <div :class="'profile-icon bg-' + payment.color">
                  <span><i :class="payment.icon"></i></span>
                </div>
                <div class="media-support-info ml-3">
                  <h6>{{ payment.title }}</h6>
                  <p class="mb-0">{{ payment.date }}</p>
                </div>
                <div class="media-support-amount ml-3">
                  <h6 :class="'text-' + payment.color">{{ payment.amount }}</h6>
                  <p class="mb-0">{{ payment.currency }}</p>
                </div>
              </li>
            </ul>
          </template>
        </iq-card>
      </b-col>
    </b-row>-->
  </b-container>
</template>
<script>
import { core } from "../../../config/pluginInit";
import gql from "graphql-tag";
import LeadStageBadge from "./LeadStageBadge";
import LeadClusterBadge from "./LeadClusterBadge";
import AmChart from "../../../components/core/charts/AmChart";
import ApexChart from "../../../components/core/charts/ApexChart";
const GET_TOP_STATS = gql`
  query {
    sentCampaigns: campaigns_aggregate(where: { status: { _eq: SENT } }) {
      aggregate {
        count
      }
    }

    openedCompanyLeads: company_leads_aggregate(where: { stage_id: { _neq: 500 } }) {
      aggregate {
        count
      }
    }

    campaigns: campaigns_aggregate {
      stats: aggregate {
        avg {
          delivery_rate
          open_rate
          ctr
          bounce_rate
        }
      }
    }
  }
`;
const LIST_COMPANY_LEADS = gql`
  query listCompanyLeads {
    company_leads(order_by: { priority_index: desc }, limit: 5) {
      id
      stage_id
      cluster
      priority_index
      number_of_clicks
      company {
        id
        name
      }
      deal_value
      campaign {
        id
        name
      }
      next_best_action {
        id
        name
      }
      last_activity
    }
  }
`;
const GET_PERFORMANCE_QUERY = gql`
  query {
    none: company_leads_aggregate(where: { stage_id: { _eq: 0 } }) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    qualified: company_leads_aggregate(where: { stage_id: { _eq: 100 } }) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    contacted: company_leads_aggregate(where: { stage_id: { _eq: 200 } }) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    met: company_leads_aggregate(where: { stage_id: { _eq: 300 } }) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    negotiating: company_leads_aggregate(where: { stage_id: { _eq: 400 } }) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
    won: company_leads_aggregate(where: { stage_id: { _eq: 500 } }) {
      aggregate {
        count
        sum {
          deal_value
        }
      }
    }
  }
`;
const stageRevenueWeight = stage => {
  switch (stage) {
    case "none":
      return 0;
    case "qualified":
      return 0.2;
    case "contacted":
      return 0.4;
    case "met":
      return 0.6;
    case "negotiating":
      return 0.8;
    case "won":
      return 1;
    default:
      return 1;
  }
};
export default {
  name: "DashboardCompanyLeads",
  components: {
    AmChart,
    ApexChart,
    LeadStageBadge,
    LeadClusterBadge
  },
  mounted() {
    core.index();
  },
  data() {
    return {
      performance: null,
      companyLeads: [],
      topStats: null,
      sortBy: "priority_index",
      sortDesc: true,
      fields: [
        { key: "cluster", label: "Cluster", sortable: false },
        { key: "company", label: "Company", sortable: false },
        { key: "next_best_action", label: "NBA", sortable: false },
        { key: "stage_id", label: "Stage", sortable: false },
        { key: "campaign", label: "Campaign", sortable: false },
        { key: "last_activity", label: "Last Activity", sortable: false },
        { key: "priority_index", label: "Priority Index", sortable: false },
        { key: "number_of_clicks", label: "Clicks", sortable: false }
      ],
      items: [
        {
          name: "Ira Membrit",
          updated: "18/10/2019",
          value: "1500$",
          status: { name: "closed", color: "success" },
          next_step: "-"
        },
        {
          name: "Pete Sariya",
          updated: "26/10/2019",
          value: "2000$",
          status: { name: "closed", color: "success" },
          next_step: "-"
        },
        {
          name: "Cliff Hanger",
          updated: "18/11/2019",
          value: "2500$",
          status: { name: "loosing", color: "danger" },
          next_step: "Call"
        },
        {
          name: "Terry Aki",
          updated: "14/12/2019",
          value: "5000$",
          status: { name: "in progress", color: "warning" },
          next_step: "SMS"
        },
        {
          name: "Anna Mull",
          updated: "24/12/2019",
          value: "10000$",
          status: { name: "in progress", color: "warning" },
          next_step: "Email"
        }
      ],
      links: [
        { url: "/special-offer", color: "success", clicks: 121 },
        { url: "/bonus", color: "success", clicks: 134 },
        { url: "/special-offer", color: "info", clicks: 90 },
        { url: "/contact", color: "success", clicks: 87 }
      ],
      paymentHistory: [
        {
          title: "Deposit from ATL",
          amount: "- 1,470",
          icon: "ri-refresh-line",
          color: "secondary",
          date: "5 march, 18:33",
          currency: "USD"
        },
        {
          title: "Deposit PayPal",
          amount: "+ 2,220",
          icon: "ri-paypal-line",
          color: "primary",
          date: "5 march, 18:33",
          currency: "USD"
        },
        {
          title: "Deposit from ATL",
          amount: "+ 250",
          icon: "ri-check-line",
          color: "primary",
          date: "5 march, 18:33",
          currency: "USD"
        },
        {
          title: "Cancelled",
          amount: "0",
          icon: "ri-close-line",
          color: "info",
          date: "5 march, 18:33",
          currency: "USD"
        },
        {
          title: "Refund",
          amount: "- 500",
          icon: "ri-arrow-go-back-fill",
          color: "info",
          date: "5 march, 18:33",
          currency: "USD"
        },
        {
          title: "Deposit from ATL",
          amount: "- 1,470",
          icon: "ri-refresh-line",
          color: "secondary",
          date: "5 march, 18:33",
          currency: "USD"
        }
      ],
      chart1: {
        series: [
          {
            name: "Performance",
            data: [120000, 68000, 32000, 18000, 1200]
          },
          {
            name: "Goal",
            data: [null, null, null, null, 10000]
          }
        ],
        chart: {
          type: "bar",
          height: 350
        },
        colors: ["#827af3", "#6ce6f4"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded"
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        xaxis: {
          categories: ["Qualified", "Contacted", "Met", "Negotiating", "Won"]
        },
        yaxis: {},
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return "$ " + val + " thousands";
            }
          }
        }
      },
      chart2: {
        series: [
          {
            name: "Desktops",
            data: [5, 10, 8, 15]
          }
        ],
        chart: {
          height: 150,
          type: "line",
          zoom: {
            enabled: false
          }
        },
        colors: ["#827af3"],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr"]
        }
      },
      darkChart2: {
        series: [
          {
            name: "Desktops",
            data: [5, 10, 8, 15]
          }
        ],
        chart: {
          height: 150,
          type: "line",
          foreColor: "#8c91b6",
          zoom: {
            enabled: false
          }
        },
        colors: ["#827af3"],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "straight"
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr"]
        }
      },
      chart3: {
        series: [44, 55, 13, 33],
        chart: {
          width: 380,
          height: 180,
          type: "donut"
        },
        dataLabels: {
          enabled: false
        },
        colors: ["#827af3", "#6ce6f4", "#a09e9e", "#fbc647"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                show: false
              }
            }
          }
        ],
        legend: {
          position: "right",
          offsetY: 0,
          height: 150
        }
      },
      darkChart3: {
        series: [44, 55, 13, 33],
        chart: {
          width: 380,
          height: 180,
          foreColor: "#8c91b6",
          type: "donut"
        },
        dataLabels: {
          enabled: false
        },
        colors: ["#827af3", "#6ce6f4", "#a09e9e", "#fbc647"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                show: false
              }
            }
          }
        ],
        legend: {
          position: "right",
          offsetY: 0,
          height: 150
        }
      }
    };
  },
  apollo: {
    companyLeads: {
      query: LIST_COMPANY_LEADS,
      fetchPolicy: "no-cache",
      update: data => {
        return data.company_leads
      }
    },
    performance() {
      return {
        query: GET_PERFORMANCE_QUERY,
        update: data => {
          return data;
        }
      };
    },
    topStats() {
      return {
        query: GET_TOP_STATS,
        update: data => {
          return data;
        }
      };
    }
  },
  computed: {
    companyLeadItems() {
      const d = this.companyLeads.map(companyLead => {
        return {
          id: companyLead.id,
          cluster: companyLead.cluster,
          company: companyLead.company,
          stage_id: companyLead.stage_id,
          campaign: companyLead.campaign,
          last_activity: companyLead.last_activity,
          priority_index: companyLead.priority_index,
          number_of_clicks: companyLead.number_of_clicks,
          next_best_action: companyLead.next_best_action?.name

        };
      });
      return d;
    },
    barChart() {
      if (!this.performance) {
        return null;
      }
      const keys = Object.keys(this.performance);
      const seriesCount = keys.map(k => this.performance[k].aggregate.count);
      return {
        title: "Bar Chart",
        type: "bar",
        bodyData: {
          chart: {
            height: 350,
            type: "bar"
          },
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          dataLabels: {
            enabled: false
          },
          series: [
            {
              name: "Count",
              data: seriesCount
            }
            // {
            //   name: "Sum",
            //   data: seriesSum
            // }
          ],
          xaxis: {
            categories: keys
          }
        }
      };
    },
    barChart2() {
      if (!this.performance) {
        return null;
      }
      const keys = Object.keys(this.performance);
      const seriesSum = keys.map(
        k => this.performance[k].aggregate.sum.deal_value
      );
      return {
        title: "Bar Chart 2",
        type: "bar2",
        bodyData: {
          chart: {
            height: 350,
            type: "bar",
            colors: ["#41B883", "#E46651", "#E46651"]
          },
          plotOptions: {
            bar: {
              horizontal: false
            }
          },
          dataLabels: {
            enabled: false
          },
          series: [
            {
              name: "Sum",
              data: seriesSum
            }
          ],
          xaxis: {
            categories: keys
          }
        }
      };
    },
    totalLeads() {
      if (!this.performance) {
        return null;
      }
      const keys = Object.keys(this.performance);
      const total = keys.reduce(
        (acc, k) => (acc += this.performance[k].aggregate.count),
        0
      );
      return total;
    },
    totalRevenue() {
      if (!this.performance) {
        return null;
      }
      const keys = Object.keys(this.performance);
      const sum = keys.reduce(
        (acc, k) => (acc += this.performance[k].aggregate.sum.deal_value * 1),
        0
      );
      return sum;
    }
  }
};
</script>

<style>
.iq-card-body {
  flex: unset;
}
/* [dir="ltr"][mode="light"] .popover {
  max-width: 600px;
} */
</style>
